import ErrorMessage from '@BUP/components/Error/Message'
import BupLoading from '@BUP/components/Loading/Main'
import { useGetCoursesByTermId } from '@BUP/hooks/Courses/useGetCoursesByTermId'
import { useGetCurrentTerm } from '@BUP/hooks/Terms/useGetCurrentTerm'
import { monitorException } from '@BUP/services/monitor'
import { createContext } from 'react'
import { useTranslation } from 'react-i18next'

export const CoursesContext = createContext()

export const CoursesContextProvider = ({ children }) => {
  const i18n = useTranslation()

  const { data: term, isLoading: loadingTerm, error: errorTerm } = useGetCurrentTerm()

  const termId = term?.id

  const {
    data: courses = [],
    isLoading: loadingCourses,
    error: errorCourses
  } = useGetCoursesByTermId(termId, { enabled: !!termId })

  if (loadingTerm || loadingCourses) {
    return <BupLoading />
  }

  if (errorTerm) {
    return <ErrorMessage message={i18n.t('common.resources.term.actions.read.failure', { context: 'current' })} />
  }

  if (errorCourses) {

    return <ErrorMessage message={i18n.t('common.resources.course.actions.read.failure_loading')} />
  }

  const coursesWithoutNivelAndGrade = courses.filter(
    course =>
      !course.tags.some(tag => tag.includes('nivel')) ||
      !course.tags.some(tag => tag.includes('grade'))
  )

  if (coursesWithoutNivelAndGrade.length > 0) {
    monitorException(new Error('The following courses have no nivel tag'), {
      extra: coursesWithoutNivelAndGrade
    })
  }

  const coursesNotValid = coursesWithoutNivelAndGrade.length > 0

  return (
    <CoursesContext.Provider value={{ courses, loadingCourses, errorCourses, coursesNotValid }}>
      {children}
    </CoursesContext.Provider>
  )
}
